import { createContext } from 'react'

import { Visibility } from 'globalTypes'

export interface Props extends ShareData {
  callback?: Function
  canManage: boolean
  refetch?: Function
  type?: string
  visibility: Visibility
}

export const Context = createContext<Props>({
  canManage: false,
  url: typeof window === 'undefined' ? undefined : window.location.href,
  visibility: undefined,
})
Context.displayName = 'ShareContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

export default Context
